import type { ReactNode } from "react";
import type { WeddingData } from "../../types/wedding";

interface Props {
  data: WeddingData;
  musicPlayer: ReactNode;
  onOpenGift: () => void;
  onOpenBarcode: () => void;
}

export function InvitationNavigation({ data, musicPlayer, onOpenGift, onOpenBarcode }: Props) {
  if (!data.navigation.enabled) return null;
  const initials = `${data.couple.groom.displayName.charAt(0) || "W"} & ${data.couple.bride.displayName.charAt(0) || "I"}`;
  return (
    <nav className="topbar" aria-label="Invitation navigation">
      <a href="#home" className="brand">{initials}</a>
      <div className="nav-links">
        {data.navigation.items.slice().sort((a, b) => a.order - b.order).map((item) => (
          item.target === "gift"
            ? <button key={item.id} type="button" className="nav-gift" onClick={onOpenGift} data-editor-section="navigation" data-editor-field={`navigation.items.${data.navigation.items.findIndex((candidate) => candidate.id === item.id)}.label`}>{item.label}</button>
            : <a key={item.id} href={`#${item.target}`} data-editor-section="navigation" data-editor-field={`navigation.items.${data.navigation.items.findIndex((candidate) => candidate.id === item.id)}.label`}>{item.label}</a>
        ))}
      </div>
      <div className="nav-tools">
        {musicPlayer}
        {data.barcode.enabled && data.barcode.image ? (
          <button type="button" className="icon-btn" onClick={onOpenBarcode}>Barcode</button>
        ) : null}
      </div>
    </nav>
  );
}
